<router-outlet />
<hlm-toaster [theme]="activeTheme()" richColors position="top-right" />